import {
  Stack,
  Text,
  Heading,
  Box,
  useResponsiveValue,
} from 'braid-design-system';
import React from 'react';

import { isStandard } from 'src/data/listing-products/products';
import {
  getProductInfo,
  type ListingProductWithPackageInfo,
} from 'src/data/listing-products/shared';
import { ListingProductCode } from 'src/generated/graphql';

interface PackageHeaderProps {
  product: ListingProductWithPackageInfo;
}

const PackageHeader = ({ product }: PackageHeaderProps) => {
  const responsiveValue = useResponsiveValue();
  const isWide = responsiveValue({
    mobile: false,
    wide: true,
  });
  const isMobile = responsiveValue({
    mobile: true,
    tablet: false,
  });
  const minHeight = isWide ? 125 : 0;

  const productInfo = getProductInfo(product);
  const isPpe = product.productCode === ListingProductCode.PayPerEnquiry;
  const isFreemium = product.productCode === ListingProductCode.Freemium;

  if (isPpe) {
    return (
      <Box
        marginX="gutter"
        marginTop="small"
        style={{ minHeight, whiteSpace: 'pre-wrap' }}
      >
        <Stack space="small" align="center">
          <Text size="large" weight="strong" tone="info">
            Pay Per Enquiry
          </Text>
          <Text size="small" align="center">
            {productInfo.description}
          </Text>
          <Box paddingTop="small">
            <Heading weight="weak" level="3" align="center" component="h2">
              No Upfront Cost
            </Heading>
          </Box>
        </Stack>
      </Box>
    );
  }

  if (isFreemium) {
    return (
      <Box
        marginX="gutter"
        marginTop="small"
        style={{ minHeight, whiteSpace: 'pre-wrap' }}
      >
        <Stack space="small" align="center">
          <Text size="large" weight="strong" tone="info">
            Free
          </Text>
          <Text size="small" align="center">
            {productInfo.description}
          </Text>
          {isMobile && (
            <Box paddingTop="small">
              <Heading level="4" weight="weak">
                Advertise your business
                <br />
                for Free
              </Heading>
            </Box>
          )}
        </Stack>
      </Box>
    );
  }

  return (
    <Box marginX="gutter" marginTop="small" style={{ minHeight }}>
      <Stack space="gutter">
        <Stack space="small" align="center">
          <Text
            size="large"
            weight="strong"
            tone={isStandard(product.productCode) ? 'promote' : 'info'}
          >
            {product.description}
          </Text>
          <Text size="small" align="center">
            {productInfo.description}
          </Text>
        </Stack>

        <Stack space="small" align="center" data={{ testid: 'package-price' }}>
          <Heading weight="weak" level="2" align="center">
            ${product.cost / 100}
          </Heading>
          <Text size="small">+ GST</Text>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PackageHeader;
